import Vue from 'vue'
import { somenteNumeros } from './global'
import { formataTelefoneComDDD, formataTelefoneSemDDD, formataTelefone0800, formataTelefone400, formataTelefoneOperadora } from '../../functions/numero'

Vue.directive('mascara-telefone', {
    inserted: function (el) {
        const limite = 14
        el.maxLength = limite
        el.addEventListener(
            'keypress',
            function (e) {
                return somenteNumeros(e)
            },
            true
        )
        el.addEventListener(
            'focus',
            function () {
                el.setAttribute('placeholder', '(__)____-____')
            },
            true
        )
        el.addEventListener(
            'blur',
            function () {
                el.setAttribute('placeholder', '')
            },
            true
        )
        el.addEventListener(
            'keyup',
            function (e) {
                let vr = e.target.value
                vr = vr.replace(/[^0-9\\.]+/g, '')
                let tam = vr.length + 1
                if (!/backspace/i.test(e.key)) {
                    if (tam == 3) {
                        e.target.value = '(' + vr.substr(0, 3) + ')' + vr.substr(3, tam)
                    } else if (tam == 7) {
                        e.target.value = '(' + vr.substr(0, 2) + ')' + vr.substr(2, 6) + '-' + vr.substr(6, tam)
                    } else if (tam == 11) {
                        e.target.value = '(' + vr.substr(0, 2) + ')' + vr.substr(2, 4) + '-' + vr.substr(6, tam)
                    } else if (tam == 12) {
                        e.target.value = '(' + vr.substr(0, 2) + ')' + vr.substr(2, 5) + '-' + vr.substr(7, tam)
                    } else if (e.target.value.length >= limite) {
                        let txt = e.target.value.substring(0, limite)
                        e.target.value = txt
                    }
                }
            },
            true
        )
    }
})
let telefoneReal
Vue.directive('mascara-telefones', {
    inserted: function (el) {
        el.addEventListener(
            'focus',
            function (e) {
                el.setAttribute('placeholder', '(__)____-____')
                telefoneReal = e.target.value
            },
            true
        )
        el.addEventListener(
            'keyup',
            function (e) {
                if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                    telefoneReal = e.target.value
                }
            },
            true
        )
        el.addEventListener(
            'blur',
            function (e) {
                el.setAttribute('placeholder', '')
                let telefone = e.target.value.replace(/[^0-9]+/g, '')
                if (['0800', '0300', '0500'].find((prefixo) => telefone.startsWith(prefixo)) && telefone.length === 11) {
                    e.target.value = formataTelefone0800(telefone)
                } else if (telefone.startsWith('400') && telefone.length === 8) {
                    e.target.value = formataTelefone400(telefone)
                } else if (telefone.startsWith('103') && telefone.length === 5) {
                    e.target.value = formataTelefoneOperadora(telefone)
                } else if (telefone.length === 10 || telefone.length === 11) {
                    e.target.value = formataTelefoneComDDD(telefone)
                } else if (telefone.length === 8 || telefone.length === 9) {
                    e.target.value = formataTelefoneSemDDD(telefone)
                } else {
                    e.target.value = telefoneReal
                }
            },
            true
        )
    }
})
